import React from 'react';
import { Icon } from '../core/Icon.jsx';
import { Button } from '../core/Button.jsx';

/** Shown in place of member-only content for non-members. */
export function PaywallCard({
  title = '这一集是会员专享',
  desc = '成为年度会员，解锁全部单集、完整文字稿和视频版。',
  cta = '成为会员',
  onJoin,
  onLogin,
  className = '',
  style,
}) {
  return (
    <div className={`bjl-paywall ${className}`} style={style}>
      <span className="bjl-paywall__glyph"><Icon name="lock" fill style={{ verticalAlign: 0 }} /></span>
      <h3 className="bjl-paywall__title">{title}</h3>
      <p className="bjl-paywall__desc">{desc}</p>
      <div className="bjl-paywall__actions">
        <Button size="lg" fullWidth onClick={onJoin}>{cta}</Button>
        {onLogin ? <Button variant="ghost" fullWidth onClick={onLogin}>已是会员？登录</Button> : null}
      </div>
    </div>
  );
}
